import { lazy } from 'react';

export const DeliveryDashboard = lazy(() => import('./pages/DeliveryDashboard'));
export const DeliveryNew = lazy(() => import('./pages/DeliveryNew'));
/** Public, token-authed customer delivery-confirmation page (NOT inside AppLayout). */
export const DeliveryConfirmation = lazy(() => import('./pages/DeliveryConfirmation'));
export const RectificationQueue = lazy(() => import('./pages/RectificationQueue'));
export const DeliveryNoteDocument = lazy(() => import('./pages/DeliveryNoteDocument'));

export const DELIVERY_ROUTES = {
  dashboard: '/staff/deliveries',
  new: '/staff/deliveries/new',
  /** Public customer confirmation: `/deliver/:token`. */
  customerConfirmation: '/deliver/:token',
  rectifications: '/staff/rectifications',
  /** Printable A4 delivery note: `/staff/deliveries/:id/note`. */
  note: '/staff/deliveries/:id/note',
} as const;
